import React, { useState } from 'react'
import { SmallSpinner } from '../../utilities/spinner/Spinner'

//Bootstrap
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
//Redux
import { rejectDocument } from '../../redux'
import { useDispatch } from 'react-redux'

function RejectDocument(props) {
  const { documentId, loading, rejecterName } = props
  const dispatch = useDispatch()

  const [rejectReason, setRejectReason] = useState('')
  const [isRejectModalShown, setIsRejectModalShown] = useState(false)

  const handleCloseRejectModal = () => setIsRejectModalShown(false)
  const handleShowRejectModal = () => setIsRejectModalShown(true)
  const handleModalCancelButton = () => {
    handleCloseRejectModal()
    setRejectReason('')
  }

  const handleRejectButton = () => {
    dispatch(
      rejectDocument({
        documentId,
        rejectReason,
        rejecterName,
      })
    )
      .then(() => {
        setRejectReason('')
        handleCloseRejectModal()
      })
      .catch((err) => {
        handleCloseRejectModal()
      })
  }
  return (
    <>
      <Button className='button-style' variant='danger' onClick={handleShowRejectModal}>
        Reject Document
      </Button>
      <Modal show={isRejectModalShown} onHide={handleCloseRejectModal} backdrop={'static'}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Are you sure you want to reject this document?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Control
              as='textarea'
              rows='2'
              placeholder='Reason for rejecting the document'
              onChange={(e) => setRejectReason(e.target.value)}
              value={rejectReason}
              disabled={loading}
            />
            <Form.Text className='text-muted'>*Rejected document cannot be signed anymore.</Form.Text>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant='success' onClick={handleRejectButton} disabled={loading}>
            <div>Yes{loading && <SmallSpinner />}</div>
          </Button>
          <Button variant='danger' onClick={handleModalCancelButton} disabled={loading}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default RejectDocument
